import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Product } from '../_models/product';
import { ProductService } from '../_services/product.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
})
export class ProductListComponent implements OnInit, AfterViewInit {
  constructor(private router: Router, private productService: ProductService) {}

  displayedColumns = ['Id', 'Name', 'ImageUrl', 'Active'];
  dataSource: MatTableDataSource<Product>;
  isDataLoaded = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getProductList();
    this.dataSource = new MatTableDataSource<Product>();
  }

  getProductList() {
    this.productService.getProducts().then((data) => {
      this.dataSource.data = data;
      this.isDataLoaded = true;
    });
  }

  addProduct() {
    this.router.navigate(['products/add']);
  }

  // Set the paginator and sort after the view init since this component will
  // be able to query its view for the initialized paginator and sort.
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data: any, filter) => {
      const dataStr = JSON.stringify(data).toLowerCase();
      return dataStr.indexOf(filter) !== -1;
    };
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  viewProduct(id: number) {
    this.router.navigate(['products/' + id]);
  }
}
